import { useRef } from 'react';
import { Transition } from 'react-transition-group';

import { useIsMounted } from '@simplywallst/ui-core';

import { transitionTimeouts } from '../constants';

import { useTransitionStatusContext } from '../TransitionStatusContext';

import { StyledBackground, StyledAccessibleButton } from './styled';

interface Props {
  zIndex?: number;
  onClick?: () => void;
}

export const Background = ({ zIndex = 9999, onClick }: Props) => {
  const { state } = useTransitionStatusContext();
  const ref = useRef<HTMLDivElement>(null);
  const hasMounted = useIsMounted();
  return (
    <Transition
      in={state === 'exiting' ? false : hasMounted}
      mountOnEnter
      unmountOnExit
      nodeRef={ref}
      timeout={transitionTimeouts}
    >
      {(state) => (
        <StyledBackground
          role="presentation"
          ref={ref}
          zIndex={zIndex}
          onClick={() => onClick?.()}
          transitionStatus={state}
        >
          <StyledAccessibleButton
            type="button"
            aria-label="close overlay"
            onClick={(e) => {
              onClick?.();
              e.stopPropagation();
            }}
          ></StyledAccessibleButton>
        </StyledBackground>
      )}
    </Transition>
  );
};
